import gql from 'graphql-tag';

export const createWaitlistNotification = gql`
    mutation CreateWaitlistNotification(
        $officeId: Int!
        $lectureTermId: Int!
        $email: String!
        $recaptchaToken: String!
        $recaptchaActionName: String!
    ) {
        createWaitlistNotification(
            officeId: $officeId
            lectureTermId: $lectureTermId
            email: $email
            recaptchaToken: $recaptchaToken
            recaptchaActionName: $recaptchaActionName
        ) {
            success
        }
    }
`;
